import React from 'react';
import { StyledAppMenuModal } from './AppMenuModal.styled';
import MenuMainOption from './MenuMainOption';
import MenuSubSection from './MenuSubSection';

const AppMenuModal = ({ options = [], selectedIndex = 0, onSelect = null, subsections = [] }) => {
  return (
    <StyledAppMenuModal>
      <div className='menu-contents'>
      <div className='menu-background'>
        <div className='menu-main-container'>
          {options.map((o, i) => (<MenuMainOption option={o} isDisabled={!!o.disabled} isSelected={selectedIndex === i} onSelect={() => onSelect(i)} />))}
        </div>
        <div className='menu-secondary-container'>
          {subsections.map((s) => <MenuSubSection subsection={s} />)}
        </div>
      </div>
      </div>
      <img className='menu-logo' src='/assets/skull.svg' />
      <div className='menu-corner menu-corner-tl' />
      <div className='menu-decorator' />
      <div className='menu-corner menu-corner-bl' />
      <div className='menu-corner menu-corner-br' />
    </StyledAppMenuModal>
  );
};

export default AppMenuModal;
